export const ERROR_ROUTE = '/error';

export const KIOSK_ROUTE = '/kiosk/:company_kiosk_id';

export const SURVEY_ROUTE = '/survey/:survey_code';
export const SURVEY_SUBMIT_ROUTE = '/survey/:survey_code/submit';
export const SURVEY_THANKYOU_ROUTE = '/survey/:survey_code/thank-you';
export const SURVEY_RESULT_ROUTE = '/survey/:survey_code/result';
export const SURVEY_EXPIRED_ROUTE = '/survey/:survey_code/expired';
